const state = {
    videos: [{ vidname: 'Bridge Leg Lift (easy)',
    name: 'Bridge Leg Lift',
    group: 3,
    level: 1,
    boxes:
     [ { t: 'Rückenlage', y: 25, h: 16 },
       { t: 'Füße nah am Becken\naufstellen', y: 69, h: 28 },
       { t: 'Kopf, Oberkörper und\nSchultern liegen\nflach auf dem Boden',
         y: 113,
         h: 43 },
       { t:
          'Becken aufheben bis\nOberkörper und\nOberschenkel eine\nLinie bilden',
         y: 170,
         h: 43 },
       { t: 'Wechselseitig die\nBeine angewinkelt\nanheben', y: 220, h: 43 } ],
    points: [ 0, 15.02, 20.17, 25.01, 31.09, 37.15, 48.15, 64.16 ],
    vimeo: 'https://vimeo.com/359527153/81e9176027',
    embed: 'https://player.vimeo.com/video/359527153',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813441421_640x360.jpg?r=pad' },
  { vidname: 'Bridge up & down (moderate)',
    name: 'Bridge up & down',
    group: 3,
    level: 2,
    boxes:
     [ { t: 'Rückenlage', y: 25, h: 16 },
       { t: 'Füße nah am Becken\naufstellen', y: 69, h: 28 },
       { t: 'Kopf, Oberkörper und\nSchultern liegen\nflach auf dem Boden',
         y: 113,
         h: 43 },
       { t:
          'Becken aufheben bis\nOberkörper und\nOberschenkel eine\nLinie bilden',
         y: 170,
         h: 43 },
       { t: 'Wechselseitig die\nBeine angewinkelt\nanheben', y: 220, h: 43 },
       { t: 'Becken heben\nund senken', y: 268, h: 28 } ],
    points: [ 0, 14.25, 20.2, 24.3, 31.16, 37.16, 42.5, 48.89, 64.5 ],
    vimeo: 'https://vimeo.com/359527188/7581b0be1d',
    embed: 'https://player.vimeo.com/video/359527188',
    duration: 65,
    preview: 'https://i.vimeocdn.com/video/813441466_640x360.jpg?r=pad' },
  { vidname: 'Bridge Walk (hard)',
    name: 'Bridge Walk',
    group: 3,
    level: 3,
    boxes:
     [ { t: 'Rückenlage', y: 25, h: 16 },
       { t: 'Kopf, Oberkörper und\nSchultern liegen\nflach auf dem Boden',
         y: 65,
         h: 43 },
       { t: 'Füße nah am Becken\naufstellen', y: 118, h: 28 },
       { t:
          'Becken aufheben bis\nOberkörper und\nOberschenkel eine\nLinie bilden',
         y: 170,
         h: 43 },
       { t:
          'Mit den Füßen nach\nVorne laufen bis die\nBeine fast gestreckt\nsind, dann wider\nzurück',
         y: 220,
         h: 70 } ],
    points: [ 0, 14.25, 20.2, 25.18, 30.71, 39.56, 50.48, 68.83 ],
    vimeo: 'https://vimeo.com/359527216/fc5161da56',
    embed: 'https://player.vimeo.com/video/359527216',
    duration: 69,
    preview: 'https://i.vimeocdn.com/video/813441493_640x360.jpg?r=pad' },
  { vidname: 'Burpees Push-Up (moderate)',
    name: 'Burpees Push-Up',
    group: 1,
    level: 2,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'In die Hocke gehen\nHände schulterbreit\naufstellne',
         y: 59,
         h: 43 },
       { t: 'Mit den Beinen\ngleichzeitig zurück in\ndie Liegestützposition\nspringen',
         y: 113,
         h: 56 },
       { t: 'Push-Up', y: 175, h: 16 },
       { t: 'Zurück in die Hocke\nspringen und\nin der Stand\naufrichten',
         y: 210,
         h: 56 } ],
    points: [ 0, 14.21, 17.61, 23.71, 35.01, 42.51, 50.9, 68.8 ],
    vimeo: 'https://vimeo.com/359527250/0d9fb5ebd5',
    embed: 'https://player.vimeo.com/video/359527250',
    duration: 69,
    preview: 'https://i.vimeocdn.com/video/813441518_640x360.jpg?r=pad' },
  { vidname: 'Burpees Push-Up Jump (hard)',
    name: 'Burpees Push-Up Jump',
    group: 1,
    level: 3,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'In die Hocke gehen\nHände schulterbreit\naufstellne',
         y: 59,
         h: 43 },
       { t: 'Mit den Beinen\ngleichzeitig zurück in\ndie Liegestützposition\nspringen',
         y: 113,
         h: 56 },
       { t: 'Push-Up', y: 175, h: 16 },
       { t: 'Zurück in die Hocke\nspringen und\nin der Stand\naufrichten',
         y: 210,
         h: 56 } ],
    points: [ 0, 15.2, 23.01, 29.33, 38.08, 44.75, 53.06, 68.66 ],
    vimeo: 'https://vimeo.com/359527293/751c52d52a',
    embed: 'https://player.vimeo.com/video/359527293',
    duration: 69,
    preview: 'https://i.vimeocdn.com/video/813441558_640x360.jpg?r=pad' },
  { vidname: 'Climber (moderate)',
    name: 'Climber',
    group: 5,
    level: 2,
    boxes:
     [ { t: 'Liegestützposition', y: 25, h: 16 },
       { t: 'Wechselseitig ein Bein\nnach Vorne führen', y: 70, h: 28 },
       { t: 'Fuß neben den\nHänden aufstellen', y: 113, h: 28 } ],
    points: [ 0, 13.5, 21.04, 27.75, 38.45, 55.98 ],
    vimeo: 'https://vimeo.com/359527315/1e5ca78886',
    embed: 'https://player.vimeo.com/video/359527315',
    duration: 56,
    preview: 'https://i.vimeocdn.com/video/813441597_640x360.jpg?r=pad' },
  { vidname: 'Crunches (easy)',
    name: 'Crunches',
    group: 6,
    level: 1,
    boxes:
     [ { t: 'Auf den Rücken legen\nFüße aufstellen', y: 20, h: 28 },
       { t: 'Hände an den\nHinterkopf', y: 70, h: 28 },
       { t: 'Langsam aufrollen\nund wider zurück', y: 113, h: 28 } ],
    points: [ 0, 13.66, 20.41, 27.8, 33.44, 49.5 ],
    vimeo: 'https://vimeo.com/359527343/1aa9b8bc26',
    embed: 'https://player.vimeo.com/video/359527343',
    duration: 50,
    preview: 'https://i.vimeocdn.com/video/813441782_640x360.jpg?r=pad' },
  { vidname: 'Decline Peek Extrem Push-Up (hard)',
    name: 'Decline Peek Extrem Push-Up',
    group: 15,
    level: 3,
    boxes:
     [ { t: 'Füße auf eine\nErhöhung wie\nKöchenzeile O.Ä.',
         y: 15,
         h: 43 },
       { t:
          'Hände flach auf den\nBoden und mit Becken\nund Oberkörper\nca. 90° Winkel bilden',
         y: 64,
         h: 56 },
       { t: 'Kopf richtung Boden\nführen, Arme\nanwinkeln und\nwider strecken',
         y: 122,
         h: 56 } ],
    points: [ 0, 13.5, 20.16, 28.9, 38.4, 56.9 ],
    vimeo: 'https://vimeo.com/359527375/50a30fe01a',
    embed: 'https://player.vimeo.com/video/359527375',
    duration: 57,
    preview: 'https://i.vimeocdn.com/video/813441674_640x360.jpg?r=pad' },
  { vidname: 'Decline Peek Push-Up (moderate)',
    name: 'Decline Peek Push-Up',
    group: 15,
    level: 2,
    boxes:
     [ { t:
          'Hände schulterbreit\nauf den Boden\n Fuße auf einen\nStuhl O.Ä.',
         y: 5,
         h: 56 },
       { t: 'Gesäß deutlich über\nShulterhöhe\nbringen',
         y: 65,
         h: 43 },
       { t: 'Becken und\nOberkörper\nca im 45° Winkel',
         y: 118,
         h: 43 },
       { t: 'Kopf/Schultern\nrichtung Boden,\nwider strecken',
         y: 168,
         h: 43 } ],
    points: [ 0, 13.3, 20, 27.12, 35.3, 45.3, 64.76 ],
    vimeo: 'https://vimeo.com/359527421/0fdc32907e',
    embed: 'https://player.vimeo.com/video/359527421',
    duration: 65,
    preview: 'https://i.vimeocdn.com/video/813441705_640x360.jpg?r=pad' },
  { vidname: 'Dips (easy)',
    name: 'Dips',
    group: 4,
    level: 1,
    boxes:
     [ { t: 'Hände mit den\nFingerspitzen nach\nvorne auf einem\nStuhl aufsetzen',
         y: 5,
         h: 56 },
       { t: 'Beine gestreckt\nnach vorne', y: 70, h: 28 },
       { t: 'Fersen in den\nBoden drücken', y: 118, h: 28 },
       { t: 'Arme beugen\nund strecken', y: 168, h: 28 } ],
    points: [ 0, 13.84, 19.75, 25.75, 29.75, 41.5, 65.4 ],
    vimeo: 'https://vimeo.com/359527449/6c7ec1ece0',
    embed: 'https://player.vimeo.com/video/359527449',
    duration: 66,
    preview: 'https://i.vimeocdn.com/video/813441742_640x360.jpg?r=pad' },
  { vidname: 'Dips Explosiv (moderate)',
    name: 'Dips Explosiv',
    group: 4,
    level: 2,
    boxes:
     [ { t: 'Hände mit den\nFingerspitzen nach\nvorne auf einem\nStuhl aufsetzen',
         y: 5,
         h: 56 },
       { t: 'Beine gestreckt\nnach vorne', y: 70, h: 28 },
       { t: 'Fersen in den\nBoden drücken', y: 118, h: 28 },
       { t: 'Arme langsam\nbeuge nund\n explosiv strecken',
         y: 168,
         h: 43 } ],
    points: [ 0, 13.7, 19.6, 24.5, 28.95, 39.6, 56.84 ],
    vimeo: 'https://vimeo.com/359527477/3b095518cc',
    embed: 'https://player.vimeo.com/video/359527477',
    duration: 57,
    preview: 'https://i.vimeocdn.com/video/813441777_640x360.jpg?r=pad' },
  { vidname: 'Dips Explosiv Leg Lift (hard)',
    name: 'Dips Explosiv Leg Lift',
    group: 4,
    level: 3,
    boxes:
     [ { t: 'Hände mit den\nFingerspitzen nach\nvorne auf einem\nStuhl aufsetzen',
         y: 5,
         h: 56 },
       { t: 'Beine gestreckt\nnach vorne', y: 70, h: 28 },
       { t: 'In wechsel ein Bein\ngestreckt in der\nLuft halten',
         y: 118,
         h: 43 },
       { t: 'Arme langsam\nbeuge nund\n explosiv strecken',
         y: 168,
         h: 43 } ],
    points: [ 0, 14.7, 21.4, 28.64, 39.16, 47.64, 60.44 ],
    vimeo: 'https://vimeo.com/359527502/16e97c4dd0',
    embed: 'https://player.vimeo.com/video/359527502',
    duration: 61,
    preview: 'https://i.vimeocdn.com/video/813441820_640x360.jpg?r=pad' },
  { vidname: 'Frogger (hard)',
    name: 'Frogger',
    group: 5,
    level: 3,
    boxes:
     [ { t: 'Liegestützposition', y: 25, h: 16 },
       { t: 'Gleichzeitig mit beiden\nFüßen neben die Hände\nspringen',
         y: 65,
         h: 43 },
       { t:
          'Hüfte absenken\nzurück in die\nAusgangposition\nspringen',
         y: 118,
         h: 56 } ],
    points: [ 0, 13.32, 20.88, 28.84, 34.44, 50.68 ],
    vimeo: 'https://vimeo.com/359527541/e0529e0a57',
    embed: 'https://player.vimeo.com/video/359527541',
    duration: 51,
    preview: 'https://i.vimeocdn.com/video/813441899_640x360.jpg?r=pad' },
  { vidname: 'Jackknifes (hard)',
    name: 'Jackknifes',
    group: 6,
    level: 3,
    boxes:
     [ { t: 'Auf den Rücken legen', y: 25, h: 16 },
       { t: 'Arme und\nBeine strecken', y: 70, h: 28 },
       { t: 'Gleichzeitig Arme\nund Beine gestreckt\nzusammenführen\nund wider ablegen',
         y: 118,
         h: 56 } ],
    points: [ 0, 12.96, 19, 25.52, 30, 43.76 ],
    vimeo: 'https://vimeo.com/359527562/f620874b73',
    embed: 'https://player.vimeo.com/video/359527562',
    duration: 44,
    preview: 'https://i.vimeocdn.com/video/813441894_640x360.jpg?r=pad' },
  { vidname: 'Jumping Lunge Push-Up (hard)',
    name: 'Jumping Lunge Push-Up',
    group: 8,
    level: 3,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'Weiter\nAusfallschritt\nnach vorne', y: 65, h: 43 },
       { t: 'Wechselsprung', y: 118, h: 16 },
       { t: 'in die Planke\nKörper komplett\ngestreckt', y: 152, h: 42 },
       { t:
          'Push-up aus\nSchulterbreiter\nHandhaltung\nzurück in der\nAusfallschritt',
         y: 196,
         h: 68 },
       { t: 'Zmieniając nogę\nwyskocz', y: 265, h: 28 } ],
    points: [ 0, 15.76, 19.12, 24.52, 32.84, 40.04, 45.56, 52.8, 72.88 ],
    vimeo: 'https://vimeo.com/359527589/55bf33a603',
    embed: 'https://player.vimeo.com/video/359527589',
    duration: 73,
    preview: 'https://i.vimeocdn.com/video/813441944_640x360.jpg?r=pad' },
  { vidname: 'Jumping Lunges (hard)',
    name: 'Jumping Lunges',
    group: 13,
    level: 3,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'Ausfallschritt\nnach vorne', y: 65, h: 28 },
       { t: 'Vorderes Bein\nAnwinkeln\nhinteres Bein\nstrecken',
         y: 112,
         h: 56 },
       { t: 'Knie möglichts Tief\nrichtung Boden', y: 172, h: 28 },
       { t: 'Wechseltseitig in den\nAusfallschritt\nspringen', y: 216, h: 43 } ],
    points: [ 0, 13.72, 16.76, 20.28, 30.84, 36.28, 41.48, 63.76 ],
    vimeo: 'https://vimeo.com/359527620/bee8923b33',
    embed: 'https://player.vimeo.com/video/359527620',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813441977_640x360.jpg?r=pad' },
  { vidname: 'Lunge Plank (easy)',
    name: 'Lunge Plank',
    group: 8,
    level: 1,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'Weiter\nAusfallschritt\nnach vorne', y: 70, h: 43 },
       { t: 'In die Planke\nKörper gestreckt', y: 122, h: 28 },
       { t: 'Zurück in den\nAusfallschritt', y: 172, h: 28 },
       { t: 'Zurück in den\nStand', y: 216, h: 28 },
       { t: 'Andere Seite', y: 270, h: 16 } ],
    points: [ 0, 14.16, 19.2, 25.08, 32.16, 35.88, 45.24, 52.92, 75.68 ],
    vimeo: 'https://vimeo.com/359527650/937b76e789',
    embed: 'https://player.vimeo.com/video/359527650',
    duration: 76,
    preview: 'https://i.vimeocdn.com/video/813442036_640x360.jpg?r=pad' },
  { vidname: 'Lunge Push-Up (moderate)',
    name: 'Lunge Push-Up',
    group: 8,
    level: 2,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'Weiter\nAusfallschritt\nnach vorne', y: 70, h: 43 },
       { t: 'In die Planke\nKörper gestreckt', y: 122, h: 28 },
       { t: 'Push-up aus\nSchulterbreiter\nHandhaltung',
         y: 162,
         h: 43 },
       { t: 'Zurück in den\nAusfallschritt', y: 216, h: 28 },
       { t: 'Andere Seite', y: 270, h: 16 } ],
    points: [ 0, 15.76, 20.8, 26.68, 34.68, 41.4, 49.24, 59.82, 82.76 ],
    vimeo: 'https://vimeo.com/359527687/904e653e37',
    embed: 'https://player.vimeo.com/video/359527687',
    duration: 83,
    preview: 'https://i.vimeocdn.com/video/813442087_640x360.jpg?r=pad' },
  { vidname: 'Lunges (easy)',
    name: 'Lunges',
    group: 13,
    level: 1,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t:
          'In wechsel Rechts/\nLinks einen weiten\nAusfallschritt nach\nvorne und weider\nzurück',
         y: 50,
         h: 70 },
       { t:
          'Körpermitte absenken\nbis das Knie fast\nden Boden berührt',
         y: 122,
         h: 43 } ],
    points: [ 0, 13.28, 16.32, 21.64, 37.56, 64.24 ],
    vimeo: 'https://vimeo.com/359527727/7b9f921aa9',
    embed: 'https://player.vimeo.com/video/359527727',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813442130_640x360.jpg?r=pad' },
  { vidname: 'Moving Plank (easy)',
    name: 'Moving Plank',
    group: 12,
    level: 1,
    boxes:
     [ { t: 'Unterarmstütz', y: 25, h: 16 },
       { t: 'Ellenbogen auf\nschulterhöhe', y: 70, h: 28 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Becken zur\nPlanke anheben', y: 168, h: 28 },
       { t: 'Oberkörper\netwas vor und\nzurück\nbewegen',
         y: 210,
         h: 56 } ],
    points: [ 0, 15.8, 20.8, 27.52, 31.96, 39.84, 48.92, 74.56 ],
    vimeo: 'https://vimeo.com/359527748/3735658fe9',
    embed: 'https://player.vimeo.com/video/359527748',
    duration: 75,
    preview: 'https://i.vimeocdn.com/video/813442157_640x360.jpg?r=pad' },
  { vidname: 'Peek Push-Up (easy)',
    name: 'Peek Push-Up',
    group: 15,
    level: 1,
    boxes:
     [ { t:
          'Hände\nSchulterbreit\nauf den Boden,\nFüße aufstellen',
         y: 10,
         h: 56 },
       { t: 'Gesäß deutlich über\nSchulterhöhe\nbringen', y: 70, h: 43 },
       { t: 'Arme strecken\ndann anwinkeln', y: 122, h: 28 },
       { t: 'mit den Kopf richtung\nBoden, den wider\nstrecken',
         y: 162,
         h: 43 } ],
    points: [ 0, 14.16, 19.88, 28.64, 36.44, 46, 70.36 ],
    vimeo: 'https://vimeo.com/359527779/3a55a626bc',
    embed: 'https://player.vimeo.com/video/359527779',
    duration: 70,
    preview: 'https://i.vimeocdn.com/video/813442175_640x360.jpg?r=pad' },
  { vidname: 'Plank Leg Raiser (moderate)',
    name: 'Plank Leg Raiser',
    group: 12,
    level: 2,
    boxes:
     [ { t: 'Unterarmstütz', y: 25, h: 16 },
       { t: 'Ellenbogen auf\nschulterhöhe', y: 70, h: 28 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Becken zur\nPlanke anheben', y: 168, h: 28 },
       { t: 'Beine Hüftbreit', y: 210, h: 28 },
       { t: 'Positionhalten\nund im wechsel\nein Bein gestreckt\nanheben',
         y: 250,
         h: 56 } ],
    points: [ 0, 15.76, 21.36, 27.52, 32, 39.84, 45.96, 59.24, 73.88 ],
    vimeo: 'https://vimeo.com/359527820/de1f8183c2',
    embed: 'https://player.vimeo.com/video/359527820',
    duration: 74,
    preview: 'https://i.vimeocdn.com/video/813442246_640x360.jpg?r=pad' },
  { vidname: 'Plank Push-Up (moderate)',
    name: 'Plank Push-Up',
    group: 10,
    level: 2,
    boxes:
     [ { t: 'Liegestützposition', y: 25, h: 16 },
       { t: 'Schulterbreit\nHandabstand', y: 70, h: 28 },
       { t:
          'Abwechselnd\nUnterarme ablegen\nund wider in die\nAusgangposition\nzurück',
         y: 122,
         h: 70 } ],
    points: [ 0, 12.84, 19.56, 26.88, 34.36, 55.76 ],
    vimeo: 'https://vimeo.com/359527846/2008de1d85',
    embed: 'https://player.vimeo.com/video/359527846',
    duration: 56,
    preview: 'https://i.vimeocdn.com/video/813442292_640x360.jpg?r=pad' },
  { vidname: 'Plank Push-Up Kneefall (easy)',
    name: 'Plank Push-Up Kneefall',
    group: 10,
    level: 1,
    boxes:
     [ { t: 'Füßspitzen anhaben\nKnie auf den Boden', y: 15, h: 28 },
       { t:
          'Arme soweit\nnach vorne\nAbstützen bis die\nHüfte gestreckt\nist',
         y: 49,
         h: 70 },
       { t: 'Dann nacheinander\nauf die Unterarme\nablegen',
         y: 121,
         h: 43 },
       { t: 'Nacheinander\nwider in die\nAusgangposition',
         y: 166,
         h: 43 } ],
    points: [ 0, 13.64, 20.36, 27.68, 38.12, 44.6, 66.28 ],
    vimeo: 'https://vimeo.com/359527877/d1c629528d',
    embed: 'https://player.vimeo.com/video/359527877',
    duration: 66,
    preview: 'https://i.vimeocdn.com/video/813442308_640x360.jpg?r=pad' },
  { vidname: 'Plank Push-Up Leg raiser (hard)',
    name: 'Plank Push-Up Leg raiser',
    group: 10,
    level: 3,
    boxes:
     [ { t: 'Liegestützposition', y: 25, h: 16 },
       { t: 'Schulterbreit\nHandabstand', y: 70, h: 28 },
       { t:
          'Abwechselnd\nUnterarme ablegen\nund wider in die\nAusgangposition\nzurück',
         y: 104,
         h: 70 },
       { t: 'In wechsel jeweils\nein Bein gestreckt\nvom Boden anheben',
         y: 176,
         h: 43 } ],
    points: [ 0, 15.76, 22.48, 28.96, 36.92, 47.64, 70.72 ],
    vimeo: 'https://vimeo.com/359527896/2412c3da0c',
    embed: 'https://player.vimeo.com/video/359527896',
    duration: 71,
    preview: 'https://i.vimeocdn.com/video/813442357_640x360.jpg?r=pad' },
  { vidname: 'Plank Rotation (hard)',
    name: 'Plank Rotation',
    group: 12,
    level: 3,
    boxes:
     [ { t: 'Unterarmstütz', y: 25, h: 16 },
       { t: 'Ellenbogen auf\nschulterhöhe', y: 70, h: 28 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Becken zur\nPlanke anheben', y: 168, h: 28 },
       { t:
          'In wechsel je einen\nArm unter dem\nOberkörper\ndurchführen\ndannach aufdrehen\nin die maximale\nRotation',
         y: 210,
         h: 100 } ],
    points: [ 0, 15.84, 21.36, 27.52, 32, 39.84, 52.92, 76 ],
    vimeo: 'https://vimeo.com/359785402/8eb2745dcd',
    embed: 'https://player.vimeo.com/video/359785402',
    duration: 76,
    preview: 'https://i.vimeocdn.com/video/813774476_640x360.jpg?r=pad' },
  { vidname: 'Push-Up Diamond (hard)',
    name: 'Push-Up Diamond',
    group: 14,
    level: 3,
    boxes:
     [ { t: 'Gestreckte Arme', y: 25, h: 16 },
       { t: 'Hände zum\nDreieck', y: 70, h: 28 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Körper bildet\ngerade Linie', y: 168, h: 28 },
       { t: 'Brustbein Richtung\nHände führen und\nwider hochdrücken', y: 210, h: 43 } ],
    points: [ 0, 12.76, 19.88, 26.44, 31.2, 42.8, 50.4, 65.6 ],
    vimeo: 'https://vimeo.com/359785445/7dcdec5652',
    embed: 'https://player.vimeo.com/video/359785445',
    duration: 66,
    preview: 'https://i.vimeocdn.com/video/813774537_640x360.jpg?r=pad' },
  { vidname: 'Push-Up Incline (easy)',
    name: 'Push-Up Incline',
    group: 14,
    level: 1,
    boxes:
     [ { t: 'Leicht erhöht\nauf Tischkante O.Ä.', y: 15, h: 28 },
       { t: 'Gestreckte Arme', y: 75, h: 16 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Handabstand\nSulterbreit', y: 168, h: 28 },
       { t: 'Körper bildet\ngerade Linie', y: 210, h: 28 },
       { t: 'Körper möglichst\nweit sinken\nlassen und wider\nhoch drücken',
         y: 255,
         h: 56 } ],
    points: [ 0, 15.8, 20.72, 27.52, 32, 39.84, 49.24, 58.88, 83 ],
    vimeo: 'https://vimeo.com/359785472/c0866a881e',
    embed: 'https://player.vimeo.com/video/359785472',
    duration: 83,
    preview: 'https://i.vimeocdn.com/video/813774551_640x360.jpg?r=pad' },
  { vidname: 'Push-Up Regular (moderate)',
    name: 'Push-Up Regular',
    group: 14,
    level: 2,
    boxes:
     [ { t: 'Gestreckte Arme', y: 25, h: 16 },
       { t: 'Handabstand\nSulterbreit', y: 70, h: 28 },
       { t: 'Fußspitzen aufstellen', y: 122, h: 16 },
       { t: 'Körper bildet\ngerade Linie', y: 168, h: 28 },
       { t: 'Körper möglichst\nweit sinken\nlassen und wider\nhoch drücken',
         y: 210,
         h: 56 } ],
    points: [ 0, 14.4, 19.28, 24.84, 31, 42, 50.16, 74.48 ],
    vimeo: 'https://vimeo.com/359785501/5f6cceba7f',
    embed: 'https://player.vimeo.com/video/359785501',
    duration: 75,
    preview: 'https://i.vimeocdn.com/video/813774653_640x360.jpg?r=pad' },
  { vidname: 'Runner (easy)',
    name: 'Runner',
    group: 5,
    level: 1,
    boxes:
     [ { t: 'Liegestützposition', y: 25, h: 16 },
       { t: 'Handabstand\nSulterbreit', y: 70, h: 28 },
       { t: 'Knie wechselseitig\nrichtung Brustkorb\nziehen',
         y: 122,
         h: 43 } ],
    points: [ 0, 13.28, 20, 27.92, 38.12, 55.68 ],
    vimeo: 'https://vimeo.com/359785532/54e9492349',
    embed: 'https://player.vimeo.com/video/359785532',
    duration: 56,
    preview: 'https://i.vimeocdn.com/video/813774693_640x360.jpg?r=pad' },
  { vidname: 'Side Plank Leg Lift (hard)',
    name: 'Side Plank Leg Lift',
    group: 2,
    level: 3,
    boxes:
     [ { t: 'Auf die Seite liegen', y: 25, h: 16 },
       { t: 'Ellenbogen unter\nSchulter absätzen', y: 70, h: 28 },
       { t: 'Füße übereinander\noberes Bein gestreckt\nanheben',
         y: 122,
         h: 43 },
       { t: 'Becken vom Boden\nheben bis der Körper\nKomplet gestreckt ist',
         y: 170,
         h: 43 },
       { t: 'Becken leicht heben\nund senken', y: 216, h: 28 } ],
    points: [ 0, 16.8, 22.4, 26.72, 33.04, 39, 46.48, 63.6 ],
    vimeo: 'https://vimeo.com/359785563/aa2e8b0268',
    embed: 'https://player.vimeo.com/video/359785563',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813774663_640x360.jpg?r=pad' },
  { vidname: 'Side Plank Rotate (moderate)',
    name: 'Side Plank Rotate',
    group: 2,
    level: 2,
    boxes:
     [ { t: 'Auf die Seite liegen', y: 25, h: 16 },
       { t: 'Ellenbogen unter\nSchulter absätzen', y: 70, h: 28 },
       { t: 'Füße übereinander\nBeine gestreckt', y: 122, h: 28 },
       { t: 'Becken vom Boden\nheben bis der Körper\nKomplet gestreckt ist',
         y: 164,
         h: 43 },
       { t:
          'Oberen Arm nach\noben strecken und\nunter den\nOberkörper ziehen\nwider in die\nStreckposition',
         y: 218,
         h: 70 } ],
    points: [ 0, 15.76, 21.36, 26.52, 29.88, 38.44, 48.68, 69.8 ],
    vimeo: 'https://vimeo.com/359785599/1890adacb5',
    embed: 'https://player.vimeo.com/video/359785599',
    duration: 70,
    preview: 'https://i.vimeocdn.com/video/813774700_640x360.jpg?r=pad' },
  { vidname: 'Side Plank up & down (easy)',
    name: 'Side Plank up & down',
    group: 2,
    level: 1,
    boxes:
     [ { t: 'Auf die Seite liegen', y: 25, h: 16 },
       { t: 'Ellenbogen unter\nSchulter absätzen', y: 70, h: 28 },
       { t: 'Füße übereinander\nBeine gestreckt', y: 122, h: 28 },
       { t: 'Becken vom Boden\nheben bis der Körper\nKomplet gestreckt ist',
         y: 164,
         h: 43 },
       { t: 'Becken heben\nund senken', y: 218, h: 28 } ],
    points: [ 0, 15.76, 21.36, 27.56, 32.04, 39.84, 53, 68.8 ],
    vimeo: 'https://vimeo.com/359785634/82325d196c',
    embed: 'https://player.vimeo.com/video/359785634',
    duration: 69,
    preview: 'https://i.vimeocdn.com/video/813774737_640x360.jpg?r=pad' },
  { vidname: 'Sit-Up Arm Raiser (moderate)',
    name: 'Sit-Up Arm Raiser',
    group: 6,
    level: 2,
    boxes:
     [ { t: 'Auf dem Rücken legen\nArme nach hinten\nablegen',
         y: 15,
         h: 43 },
       { t: 'Ausrollen bis zur\nsitzposition, Arme\nnach oben gestreckt',
         y: 70,
         h: 43 },
       { t: 'Wider in die\nAusgangposition\nausrollen', y: 122, h: 43 } ],
    points: [ 0, 13.68, 19.72, 27.04, 33.64, 49.52 ],
    vimeo: 'https://vimeo.com/359785649/5bdb936203',
    embed: 'https://player.vimeo.com/video/359785649',
    duration: 50,
    preview: 'https://i.vimeocdn.com/video/813774781_640x360.jpg?r=pad' },
  { vidname: 'Skydiver (easy)',
    name: 'Skydiver',
    group: 11,
    level: 1,
    boxes:
     [ { t: 'Bauchlage', y: 25, h: 16 },
       { t: 'Beine liecht\ngeöffner vom\nBoden heben', y: 70, h: 43 },
       { t: 'Arme nach hinten\nHanddrücken nach\noben, etwas anheben',
         y: 115,
         h: 43 },
       { t: 'Kopf mit Blick\nnach unten vom\nBoden heben', y: 162, h: 43 },
       { t: 'Paddelbewegungen\nmit Armen und\nBeinen wechselseitig', y: 210, h: 43 } ],
    points: [ 0, 13.68, 19.32, 23.64, 29.8, 38.6, 46.04, 58.84 ],
    vimeo: 'https://vimeo.com/359785699/abd59a62d4',
    embed: 'https://player.vimeo.com/video/359785699',
    duration: 59,
    preview: 'https://i.vimeocdn.com/video/813774830_640x360.jpg?r=pad' },
  { vidname: 'Skydriver Extreme (hard)',
    name: 'Skydriver Extreme',
    group: 11,
    level: 3,
    boxes:
     [ { t: 'Bauchlage', y: 25, h: 16 },
       { t: 'Beine liecht\ngeöffner vom\nBoden heben', y: 70, h: 43 },
       { t: 'Arme nach Vorne\nHanddrücken nach\noben, etwas anheben',
         y: 115,
         h: 43 },
       { t: 'Kopf mit Blick\nnach unten vom\nBoden heben', y: 162, h: 43 },
       { t: 'Paddelbewegungen\nmit Armen und\nBeinen wechselseitig', y: 210, h: 43 } ],
    points: [ 0, 13.72, 19.36, 23.64, 30, 38.6, 46.24, 64.12 ],
    vimeo: 'https://vimeo.com/359785793/926a9e63dc',
    embed: 'https://player.vimeo.com/video/359785793',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813774957_640x360.jpg?r=pad' },
  { vidname: 'Sprawls (easy)',
    name: 'Sprawls',
    group: 1,
    level: 1,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'In die Hocke gehen\nHände Schulterbreit\naufstellen', y: 70, h: 43 },
       { t: 'Mit den Beinen\ngleichzeitig zurück in\ndie Liegestützposition\nspringen',
         y: 115,
         h: 56 },
       { t:
          'In die Hocke\nzurück springen\nund in den Stand\nausrichten',
         y: 173,
         h: 56 } ],
    points: [ 0, 14.48, 22.28, 28.52, 37.28, 45.68, 63.56 ],
    vimeo: 'https://vimeo.com/359785852/b4a61d1b8e',
    embed: 'https://player.vimeo.com/video/359785852',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813774985_640x360.jpg?r=pad' },
  { vidname: 'V-Squat (easy)',
    name: 'V-Squat',
    group: 9,
    level: 1,
    boxes:
     [ { t: 'Fester\nSchulterbreiter Stand', y: 20, h: 28 },
       { t: 'Mit Rechts beginnen\neinen Schritt nach\nvorne ausen (V-Step)', y: 70, h: 43 },
       { t: 'Breiter Stand\nTiefer Squad', y: 117, h: 28 },
       { t:
          'Zurück in den Stand\nund mit Links\nbeginnen wieder\neinen Schritt\nzurück in den\nHüftbreiten Stand',
         y: 164,
         h: 70 } ],
    points: [ 0, 11.08, 14.16, 19.44, 24.8, 38.16, 55.24 ],
    vimeo: 'https://vimeo.com/359785888/7010ec9acc',
    embed: 'https://player.vimeo.com/video/359785888',
    duration: 55,
    preview: 'https://i.vimeocdn.com/video/813775033_640x360.jpg?r=pad' },
  { vidname: 'V-Squat Double-Jump (hard)',
    name: 'V-Squat Double-Jump',
    group: 9,
    level: 3,
    boxes:
     [ { t: 'Fester\nSchulterbreiter Stand', y: 20, h: 28 },
       { t: 'Mit Rechts beginnen\neinen Schritt nach\nvorne ausen (V-Step)', y: 70, h: 43 },
       { t:
          'Breiter Stand\nTiefer Squad.\nDoppelter\nStrecksprung',
         y: 115,
         h: 56 },
       { t:
          'Zurück in den Stand\nund mit Links\nbeginnen wieder\neinen Schritt\nzurück in den\nHüftbreiten Stand',
         y: 173,
         h: 70 } ],
    points: [ 1.32, 14.4, 17.44, 22.72, 28.08, 41.48, 62.32 ],
    vimeo: 'https://vimeo.com/359785924/6897425e32',
    embed: 'https://player.vimeo.com/video/359785924',
    duration: 61,
    preview: 'https://i.vimeocdn.com/video/813775080_640x360.jpg?r=pad' },
  { vidname: 'V-Squat-Jump (moderate)',
    name: 'V-Squat-Jump',
    group: 9,
    level: 2,
    boxes:
     [ { t: 'Festerstand', y: 25, h: 16 },
       { t: 'Mit Rechts beginnen\neinen Schritt nach\nvorne ausen (V-Step)', y: 70, h: 43 },
       { t: 'Breiter Stand\nTiefer Squad.\nStrecksprung',
         y: 115,
         h: 43 },
       { t:
          'Zurück in den Stand\nund mit Links\nbeginnen wieder\neinen Schritt\nzurück in den\nHüftbreiten Stand',
         y: 173,
         h: 70 } ],
    points: [ 0, 10.88, 13.88, 19.32, 24.6, 37.92, 54.88 ],
    vimeo: 'https://vimeo.com/359785970/3f1ae5e8fa',
    embed: 'https://player.vimeo.com/video/359785970',
    duration: 55,
    preview: 'https://i.vimeocdn.com/video/813775150_640x360.jpg?r=pad' },
  { vidname: 'Walking Lunges (moderate)',
    name: 'Walking Lunges',
    group: 13,
    level: 2,
    boxes:
     [ { t: 'Fester\nSchulterbreiter Stand', y: 20, h: 28 },
       { t: 'In wechsel Rechts/\nLinks mit weiten\nAusfallschritt\nnach\nvorne laufen',
         y: 60,
         h: 56 },
       { t: 'Knie bis kurz\nüber den Boden', y: 118, h: 28 },
       { t: 'Zwischen den\nSchritten wieder\naufrichten',
         y: 173,
         h: 43 } ],
    points: [ 0, 17.68, 20.72, 25.44, 36.08, 48.96, 76.28 ],
    vimeo: 'https://vimeo.com/359786007/9b7ce7a5f7',
    embed: 'https://player.vimeo.com/video/359786007',
    duration: 76,
    preview: 'https://i.vimeocdn.com/video/813775177_640x360.jpg?r=pad' },
  { vidname: 'Windmill Push-Up (moderate)',
    name: 'Windmill Push-Up',
    group: 7,
    level: 2,
    boxes:
     [ { t: 'Gestreckte Arme\nHände auf\nSchulterhöhe',
         y: 15,
         h: 43 },
       { t: 'Körper stabilisieren\nBecken gestreckt', y: 70, h: 28 },
       { t: 'Beine gestreckt\nnach hinten,\nFußspitzen aufstellen', y: 116, h: 43 },
       { t:
          'Im wechsel einen\nArm seitlich nach\noben führen\nhinternherschaun.\nWider absetzen',
         y: 161,
         h: 70 },
       { t: 'Push-up', y: 233, h: 16 } ],
    points: [ 0, 20.36, 26, 30.28, 36.6, 45.4, 56.2, 76.2 ],
    vimeo: 'https://vimeo.com/359786038/3b00c8f01f',
    embed: 'https://player.vimeo.com/video/359786038',
    duration: 76,
    preview: 'https://i.vimeocdn.com/video/813775219_640x360.jpg?r=pad' },
  { vidname: 'Windmill Push-Up Diamond (hard)',
    name: 'Windmill Push-Up Diamond',
    group: 7,
    level: 3,
    boxes:
     [ { t: 'Gestreckte Arme,\nHände bilden\nDreieck', y: 15, h: 43 },
       { t: 'Körper stabilisieren\nBecken gestreckt', y: 70, h: 28 },
       { t: 'Beine gestreckt\nnach hinten,\nFußspitzen aufstellen', y: 116, h: 43 },
       { t:
          'Im wechsel einen\nArm seitlich nach\noben führen\nhinternherschaun.\nWider absetzen',
         y: 163,
         h: 70 },
       { t: 'Push-up', y: 235, h: 16 } ],
    points: [ 0, 19.88, 23.92, 32.68, 37.92, 47.12, 56.44, 75 ],
    vimeo: 'https://vimeo.com/359786066/e8f7e888d5',
    embed: 'https://player.vimeo.com/video/359786066',
    duration: 75,
    preview: 'https://i.vimeocdn.com/video/813775245_640x360.jpg?r=pad' },
  { vidname: 'Windmill Push-Up incline (easy)',
    name: 'Windmill Push-Up incline',
    group: 7,
    level: 1,
    boxes:
     [ { t: 'Mit gestreckte\nArmen leicht\nerhöht auf\nTischkante O.Ä.',
         y: 5,
         h: 56 },
       { t: 'Hände auf\nSchulterhöhe\nFußspitze\naufstellen',
         y: 65,
         h: 56 },
       { t: 'Körper stabilisieren\nBecken gestreckt', y: 124, h: 28 },
       { t:
          'Im wechsel einen\nArm seitlich nach\noben führen,\nHinterherschaun,\nwieder absetzen',
         y: 156,
         h: 56 },
       { t: 'Push-up', y: 220, h: 16 } ],
    points: [ 0, 14.16, 19.76, 24.08, 30.4, 39.2, 50.04, 73.4 ],
    vimeo: 'https://vimeo.com/359787859/6270af5df7',
    embed: 'https://player.vimeo.com/video/359787859',
    duration: 73,
    preview: 'https://i.vimeocdn.com/video/813777581_640x360.jpg?r=pad' },
  { vidname: 'Wingsuiter (moderate)',
    name: 'Wingsuiter',
    group: 11,
    level: 2,
    boxes:
     [ { t: 'Bauchlage', y: 25, h: 16 },
       { t: 'Beine liecht\ngeöffner vom\nBoden heben', y: 70, h: 43 },
       { t: 'Arme nach Vorne\nHanddrücken nach\noben, etwas anheben',
         y: 115,
         h: 43 },
       { t: 'Kopf mit Blick\nnach unten vom\nBoden heben', y: 162, h: 43 },
       { t:
          'Arme in\nHalbkreissbewegeung\nnach vorne führen\nund wider zurück,\nBeine dabei öffnen\nund schließen',
         y: 210,
         h: 84 } ],
    points: [ 0, 13.72, 19.36, 23.64, 28.88, 37.64, 45.08, 64 ],
    vimeo: 'https://vimeo.com/359787891/55057f1695',
    embed: 'https://player.vimeo.com/video/359787891',
    duration: 64,
    preview: 'https://i.vimeocdn.com/video/813777633_640x360.jpg?r=pad' }
  ],
combos: [{ name: 'Zinedine (moderate)',
vimeo: 'https://vimeo.com/360092694/bea7417d32',
embed: 'https://player.vimeo.com/video/360092694',
duration: 363,
groups: [ 7, 5, 10, 4, 13 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814174533_640x360.jpg?r=pad' },
{ name: 'Zinedine (hard)',
vimeo: 'https://vimeo.com/360092623/c0bf90b555',
embed: 'https://player.vimeo.com/video/360092623',
duration: 363,
groups: [ 7, 5, 10, 4, 13 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814174452_640x360.jpg?r=pad' },
{ name: 'Zinedine (easy)',
vimeo: 'https://vimeo.com/360092601/55d71ff18b',
embed: 'https://player.vimeo.com/video/360092601',
duration: 367,
groups: [ 7, 5, 10, 4, 13 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814174426_640x360.jpg?r=pad' },
{ name: 'X-Men (moderate)',
vimeo: 'https://vimeo.com/360092558/bfa62e6038',
embed: 'https://player.vimeo.com/video/360092558',
duration: 351,
groups: [ 9, 15, 2, 11, 10 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174381_640x360.jpg?r=pad' },
{ name: 'X-Men (hard)',
vimeo: 'https://vimeo.com/360092529/3d83dead07',
embed: 'https://player.vimeo.com/video/360092529',
duration: 359,
groups: [ 9, 15, 2, 11, 10 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174353_640x360.jpg?r=pad' },
{ name: 'X-Men (easy)',
vimeo: 'https://vimeo.com/360092367/3a5b760e70',
embed: 'https://player.vimeo.com/video/360092367',
duration: 362,
groups: [ 9, 15, 2, 11, 10 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174199_640x360.jpg?r=pad' },
{ name: 'Willis (moderate)',
vimeo: 'https://vimeo.com/360092317/d70711e60e',
embed: 'https://player.vimeo.com/video/360092317',
duration: 357,
groups: [ 13, 10, 3, 11, 9 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174122_640x360.jpg?r=pad' },
{ name: 'Willis (hard)',
vimeo: 'https://vimeo.com/360092292/d1c99f4dc4',
embed: 'https://player.vimeo.com/video/360092292',
duration: 371,
groups: [ 13, 10, 3, 11, 9 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174087_640x360.jpg?r=pad' },
{ name: 'Willis (easy)',
vimeo: 'https://vimeo.com/360092262/b6a0748bd4',
embed: 'https://player.vimeo.com/video/360092262',
duration: 351,
groups: [ 13, 10, 3, 11, 9 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814174059_640x360.jpg?r=pad' },
{ name: 'Wesley (moderate)',
vimeo: 'https://vimeo.com/360091704/b2604d1355',
embed: 'https://player.vimeo.com/video/360091704',
duration: 364,
groups: [ 2, 7, 4, 9, 11 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814174029_640x360.jpg?r=pad' },
{ name: 'Wesley (hard)',
vimeo: 'https://vimeo.com/360091665/920db19528',
embed: 'https://player.vimeo.com/video/360091665',
duration: 366,
groups: [ 2, 7, 4, 9, 11 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814173251_640x360.jpg?r=pad' },
{ name: 'Wesley (easy)',
vimeo: 'https://vimeo.com/360091621/37f9363e68',
embed: 'https://player.vimeo.com/video/360091621',
duration: 364,
groups: [ 2, 7, 4, 9, 11 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814173202_640x360.jpg?r=pad' },
{ name: 'Voller (moderate)',
vimeo: 'https://vimeo.com/360091592/92bc6b3d64',
embed: 'https://player.vimeo.com/video/360091592',
duration: 222,
groups: [ 5, 7, 1 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814173146_640x360.jpg?r=pad' },
{ name: 'Voller (hard)',
vimeo: 'https://vimeo.com/360091571/3f9fcf6e65',
embed: 'https://player.vimeo.com/video/360091571',
duration: 215,
groups: [ 5, 7, 1 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814173128_640x360.jpg?r=pad' },
{ name: 'Voller (easy)',
vimeo: 'https://vimeo.com/360091545/df5c8aa869',
embed: 'https://player.vimeo.com/video/360091545',
duration: 214,
groups: [ 5, 7, 1 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814173073_640x360.jpg?r=pad' },
{ name: 'Tyson (moderate)',
vimeo: 'https://vimeo.com/360091521/2305973fe7',
embed: 'https://player.vimeo.com/video/360091521',
duration: 218,
groups: [ 5, 3, 13 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814173046_640x360.jpg?r=pad' },
{ name: 'Tyson (hard)',
vimeo: 'https://vimeo.com/360091498/b74fa1b271',
embed: 'https://player.vimeo.com/video/360091498',
duration: 204,
groups: [ 5, 3, 13 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814173014_640x360.jpg?r=pad' },
{ name: 'Tyson (easy)',
vimeo: 'https://vimeo.com/360091480/e4a6a7493e',
embed: 'https://player.vimeo.com/video/360091480',
duration: 205,
groups: [ 5, 3, 13 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172992_640x360.jpg?r=pad' },
{ name: 'Triple X (moderate)',
vimeo: 'https://vimeo.com/360091440/565d2c20c7',
embed: 'https://player.vimeo.com/video/360091440',
duration: 521,
groups: [ 5, 7, 1, 4, 12, 13, 6 ],
level: 2,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814172972_640x360.jpg?r=pad' },
{ name: 'Triple X (hard)',
vimeo: 'https://vimeo.com/360091408/5215e4eede',
embed: 'https://player.vimeo.com/video/360091408',
duration: 501,
groups: [ 5, 7, 1, 4, 12, 13, 6 ],
level: 3,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814172933_640x360.jpg?r=pad' },
{ name: 'Triple X (easy)',
vimeo: 'https://vimeo.com/360091372/cc8d187a95',
embed: 'https://player.vimeo.com/video/360091372',
duration: 509,
groups: [ 5, 7, 1, 4, 12, 13, 6 ],
level: 1,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814172886_640x360.jpg?r=pad' },
{ name: 'Tatum (moderate)',
vimeo: 'https://vimeo.com/360091340/2ffa7d16ff',
embed: 'https://player.vimeo.com/video/360091340',
duration: 498,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172852_640x360.jpg?r=pad' },
{ name: 'Tatum (hard)',
vimeo: 'https://vimeo.com/360091300/ac13e3015e',
embed: 'https://player.vimeo.com/video/360091300',
duration: 512,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172825_640x360.jpg?r=pad' },
{ name: 'Tatum (easy)',
vimeo: 'https://vimeo.com/360091271/3b12b39e14',
embed: 'https://player.vimeo.com/video/360091271',
duration: 504,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172781_640x360.jpg?r=pad' },
{ name: 'Statham (moderate)',
vimeo: 'https://vimeo.com/360091235/636fc20c7b',
embed: 'https://player.vimeo.com/video/360091235',
duration: 530,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 2,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172733_640x360.jpg?r=pad' },
{ name: 'Statham (hard)',
vimeo: 'https://vimeo.com/360091194/31d47de08a',
embed: 'https://player.vimeo.com/video/360091194',
duration: 499,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 3,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172699_640x360.jpg?r=pad' },
{ name: 'Statham (easy)',
vimeo: 'https://vimeo.com/360091162/7950f2cfb4',
embed: 'https://player.vimeo.com/video/360091162',
duration: 526,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 1,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172651_640x360.jpg?r=pad' },
{ name: 'Stallone (moderate)',
vimeo: 'https://vimeo.com/360091140/bacdd687f5',
embed: 'https://player.vimeo.com/video/360091140',
duration: 227,
groups: [ 5, 12, 13 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172591_640x360.jpg?r=pad' },
{ name: 'Stallone (hard)',
vimeo: 'https://vimeo.com/360091105/89cd23e5f5',
embed: 'https://player.vimeo.com/video/360091105',
duration: 212,
groups: [ 5, 12, 13 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172559_640x360.jpg?r=pad' },
{ name: 'Stallone (easy)',
vimeo: 'https://vimeo.com/360091078/2d911248b7',
embed: 'https://player.vimeo.com/video/360091078',
duration: 216,
groups: [ 5, 12, 13 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172521_640x360.jpg?r=pad' },
{ name: 'Sommerhalder (moderate)',
vimeo: 'https://vimeo.com/360091053/425edcc899',
embed: 'https://player.vimeo.com/video/360091053',
duration: 397,
groups: [ 10, 5, 11, 9, 15, 6 ],
level: 2,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172493_640x360.jpg?r=pad' },
{ name: 'Sommerhalder (hard)',
vimeo: 'https://vimeo.com/360091028/80746029fe',
embed: 'https://player.vimeo.com/video/360091028',
duration: 400,
groups: [ 10, 5, 11, 9, 15, 6 ],
level: 3,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172462_640x360.jpg?r=pad' },
{ name: 'Sommerhalder (easy)',
vimeo: 'https://vimeo.com/360090985/7e571dea7a',
embed: 'https://player.vimeo.com/video/360090985',
duration: 408,
groups: [ 10, 5, 11, 9, 15, 6 ],
level: 1,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814172433_640x360.jpg?r=pad' },
{ name: 'Rumpf-Special (moderate)',
vimeo: 'https://vimeo.com/360090931/3b0bdbaa92',
embed: 'https://player.vimeo.com/video/360090931',
duration: 304,
groups: [ 12, 2, 3, 11 ],
level: 2,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172367_640x360.jpg?r=pad' },
{ name: 'Rumpf-Special (hard)',
vimeo: 'https://vimeo.com/360090660/177c88d578',
embed: 'https://player.vimeo.com/video/360090660',
duration: 304,
groups: [ 12, 2, 3, 11 ],
level: 3,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814172028_640x360.jpg?r=pad' },
{ name: 'Rumpf-Special (easy)',
vimeo: 'https://vimeo.com/360090638/ef6aea031c',
embed: 'https://player.vimeo.com/video/360090638',
duration: 298,
groups: [ 12, 2, 3, 11 ],
level: 1,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171985_640x360.jpg?r=pad' },
{ name: 'Riddick (moderate)',
vimeo: 'https://vimeo.com/360090605/da953c681c',
embed: 'https://player.vimeo.com/video/360090605',
duration: 483,
groups: [ 5, 3, 9, 14, 6, 11, 4 ],
level: 2,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814171966_640x360.jpg?r=pad' },
{ name: 'Riddick (hard)',
vimeo: 'https://vimeo.com/360090575/b29393a7b6',
embed: 'https://player.vimeo.com/video/360090575',
duration: 478,
groups: [ 5, 3, 9, 14, 6, 11, 4 ],
level: 3,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814171924_640x360.jpg?r=pad' },
{ name: 'Riddick (easy)',
vimeo: 'https://vimeo.com/360090540/85903e6399',
embed: 'https://player.vimeo.com/video/360090540',
duration: 495,
groups: [ 5, 3, 9, 14, 6, 11, 4 ],
level: 1,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814171887_640x360.jpg?r=pad' },
{ name: 'Reynolds (moderate)',
vimeo: 'https://vimeo.com/360090513/5c07981bb1',
embed: 'https://player.vimeo.com/video/360090513',
duration: 373,
groups: [ 1, 4, 7, 3, 11 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171848_640x360.jpg?r=pad' },
{ name: 'Reynolds (hard)',
vimeo: 'https://vimeo.com/360090483/123f407a7c',
embed: 'https://player.vimeo.com/video/360090483',
duration: 379,
groups: [ 1, 4, 7, 3, 11 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171819_640x360.jpg?r=pad' },
{ name: 'Reynolds (easy)',
vimeo: 'https://vimeo.com/360090446/81797899fd',
embed: 'https://player.vimeo.com/video/360090446',
duration: 367,
groups: [ 1, 4, 7, 3, 11 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171776_640x360.jpg?r=pad' },
{ name: 'Predator (moderate)',
vimeo: 'https://vimeo.com/360090402/fbe1e466d2',
embed: 'https://player.vimeo.com/video/360090402',
duration: 355,
groups: [ 4, 13, 5, 14, 6 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814171721_640x360.jpg?r=pad' },
{ name: 'Predator (hard)',
vimeo: 'https://vimeo.com/360090365/a97d66db83',
embed: 'https://player.vimeo.com/video/360090365',
duration: 326,
groups: [ 4, 13, 5, 14, 6 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814171693_640x360.jpg?r=pad' },
{ name: 'Predator (easy)',
vimeo: 'https://vimeo.com/360090340/c4bc3364d8',
embed: 'https://player.vimeo.com/video/360090340',
duration: 360,
groups: [ 4, 13, 5, 14, 6 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814171661_640x360.jpg?r=pad' },
{ name: 'Pitt (moderate)',
vimeo: 'https://vimeo.com/360090303/44ac30bfa0',
embed: 'https://player.vimeo.com/video/360090303',
duration: 523,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171635_640x360.jpg?r=pad' },
{ name: 'Pitt (hard)',
vimeo: 'https://vimeo.com/360090269/90baaa2e04',
embed: 'https://player.vimeo.com/video/360090269',
duration: 498,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171580_640x360.jpg?r=pad' },
{ name: 'Pitt (easy)',
vimeo: 'https://vimeo.com/360090229/82d5bf74bc',
embed: 'https://player.vimeo.com/video/360090229',
duration: 522,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171526_640x360.jpg?r=pad' },
{ name: 'Oberkörper-Special (moderate)',
vimeo: 'https://vimeo.com/360090205/537ac771e0',
embed: 'https://player.vimeo.com/video/360090205',
duration: 284,
groups: [ 14, 4, 15, 5 ],
level: 2,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171480_640x360.jpg?r=pad' },
{ name: 'Oberkörper-Special (hard)',
vimeo: 'https://vimeo.com/360090171/d4f12af42d',
embed: 'https://player.vimeo.com/video/360090171',
duration: 265,
groups: [ 14, 4, 15, 5 ],
level: 3,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814171426_640x360.jpg?r=pad' },
{ name: 'Oberkörper-Special (easy)',
vimeo: 'https://vimeo.com/360089343/75fa3bbd21',
embed: 'https://player.vimeo.com/video/360089343',
duration: 306,
groups: [ 14, 4, 15, 5 ],
level: 1,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814170335_640x360.jpg?r=pad' },
{ name: 'Mister T (moderate)',
vimeo: 'https://vimeo.com/360089317/37bbc4de9c',
embed: 'https://player.vimeo.com/video/360089317',
duration: 255,
groups: [ 14, 7, 8 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814170303_640x360.jpg?r=pad' },
{ name: 'Mister T (hard)',
vimeo: 'https://vimeo.com/360089298/6db81305d9',
embed: 'https://player.vimeo.com/video/360089298',
duration: 235,
groups: [ 14, 7, 8 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814170278_640x360.jpg?r=pad' },
{ name: 'Mister T (easy)',
vimeo: 'https://vimeo.com/360089270/334e5976ea',
embed: 'https://player.vimeo.com/video/360089270',
duration: 253,
groups: [ 14, 7, 8 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814170241_640x360.jpg?r=pad' },
{ name: 'McConaughey (moderate)',
vimeo: 'https://vimeo.com/360089241/b8dcce404a',
embed: 'https://player.vimeo.com/video/360089241',
duration: 356,
groups: [ 3, 12, 15, 9, 5 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814170203_640x360.jpg?r=pad' },
{ name: 'McConaughey (hard)',
vimeo: 'https://vimeo.com/360089203/125a2334ff',
embed: 'https://player.vimeo.com/video/360089203',
duration: 356,
groups: [ 3, 12, 15, 9, 5 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814170178_640x360.jpg?r=pad' },
{ name: 'McConaughey (easy)',
vimeo: 'https://vimeo.com/360089169/fb70a97c34',
embed: 'https://player.vimeo.com/video/360089169',
duration: 362,
groups: [ 3, 12, 15, 9, 5 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814170125_640x360.jpg?r=pad' },
{ name: 'McClane (moderate)',
vimeo: 'https://vimeo.com/360089137/3e40b18deb',
embed: 'https://player.vimeo.com/video/360089137',
duration: 534,
groups: [ 10, 2, 13, 15, 3, 8, 4 ],
level: 2,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814170093_640x360.jpg?r=pad' },
{ name: 'McClane (hard)',
vimeo: 'https://vimeo.com/360089106/9e0733486a',
embed: 'https://player.vimeo.com/video/360089106',
duration: 520,
groups: [ 10, 2, 13, 15, 3, 8, 4 ],
level: 3,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814170061_640x360.jpg?r=pad' },
{ name: 'McClane (easy)',
vimeo: 'https://vimeo.com/360088589/2110b741b4',
embed: 'https://player.vimeo.com/video/360088589',
duration: 538,
groups: [ 10, 2, 13, 15, 3, 8, 4 ],
level: 1,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814169466_640x360.jpg?r=pad' },
{ name: 'Mc Fly (moderate)',
vimeo: 'https://vimeo.com/360088573/5c884aa067',
embed: 'https://player.vimeo.com/video/360088573',
duration: 209,
groups: [ 14, 6, 11 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814169387_640x360.jpg?r=pad' },
{ name: 'Mc Fly (hard)',
vimeo: 'https://vimeo.com/360088544/14c3b0a6b5',
embed: 'https://player.vimeo.com/video/360088544',
duration: 195,
groups: [ 14, 6, 11 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814169365_640x360.jpg?r=pad' },
{ name: 'Mc Fly (easy)',
vimeo: 'https://vimeo.com/360088524/6ece866c29',
embed: 'https://player.vimeo.com/video/360088524',
duration: 212,
groups: [ 14, 6, 11 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814169336_640x360.jpg?r=pad' },
{ name: 'Levine (moderate)',
vimeo: 'https://vimeo.com/360088503/7f6fd28226',
embed: 'https://player.vimeo.com/video/360088503',
duration: 210,
groups: [ 15, 2, 9 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814169305_640x360.jpg?r=pad' },
{ name: 'Levine (hard)',
vimeo: 'https://vimeo.com/360088479/d8745e7d87',
embed: 'https://player.vimeo.com/video/360088479',
duration: 203,
groups: [ 15, 2, 9 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814169278_640x360.jpg?r=pad' },
{ name: 'Levine (easy)',
vimeo: 'https://vimeo.com/360088453/6678cda5bc',
embed: 'https://player.vimeo.com/video/360088453',
duration: 215,
groups: [ 15, 2, 9 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814169259_640x360.jpg?r=pad' },
{ name: 'Leto (moderate)',
vimeo: 'https://vimeo.com/360088244/02d86ebc10',
embed: 'https://player.vimeo.com/video/360088244',
duration: 356,
groups: [ 14, 11, 6, 4, 1 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814169009_640x360.jpg?r=pad' },
{ name: 'Leto (hard)',
vimeo: 'https://vimeo.com/360088215/0e920c8d0d',
embed: 'https://player.vimeo.com/video/360088215',
duration: 345,
groups: [ 14, 11, 6, 4, 1 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168981_640x360.jpg?r=pad' },
{ name: 'Leto (easy)',
vimeo: 'https://vimeo.com/360088180/000093b3bc',
embed: 'https://player.vimeo.com/video/360088180',
duration: 362,
groups: [ 14, 11, 6, 4, 1 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168937_640x360.jpg?r=pad' },
{ name: 'Law (moderate)',
vimeo: 'https://vimeo.com/360088157/de5741a0db',
embed: 'https://player.vimeo.com/video/360088157',
duration: 233,
groups: [ 15, 3, 8 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168896_640x360.jpg?r=pad' },
{ name: 'Law (hard)',
vimeo: 'https://vimeo.com/360088061/bfd05b3bdd',
embed: 'https://player.vimeo.com/video/360088061',
duration: 220,
groups: [ 15, 3, 8 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168783_640x360.jpg?r=pad' },
{ name: 'Law (easy)',
vimeo: 'https://vimeo.com/360088031/a73f7e4e3b',
embed: 'https://player.vimeo.com/video/360088031',
duration: 231,
groups: [ 15, 3, 8 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168749_640x360.jpg?r=pad' },
{ name: 'Kutcher (moderate)',
vimeo: 'https://vimeo.com/360087958/7d5b05e615',
embed: 'https://player.vimeo.com/video/360087958',
duration: 223,
groups: [ 10, 2, 13 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168656_640x360.jpg?r=pad' },
{ name: 'Kutcher (hard)',
vimeo: 'https://vimeo.com/360087925/574bbc0b90',
embed: 'https://player.vimeo.com/video/360087925',
duration: 219,
groups: [ 10, 2, 13 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168626_640x360.jpg?r=pad' },
{ name: 'Kutcher (easy)',
vimeo: 'https://vimeo.com/360087893/388c67cf48',
embed: 'https://player.vimeo.com/video/360087893',
duration: 220,
groups: [ 10, 2, 13 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168591_640x360.jpg?r=pad' },
{ name: 'Jordan (moderate)',
vimeo: 'https://vimeo.com/360087775/56d07846cb',
embed: 'https://player.vimeo.com/video/360087775',
duration: 230,
groups: [ 4, 2, 8 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168443_640x360.jpg?r=pad' },
{ name: 'Jordan (hard)',
vimeo: 'https://vimeo.com/360087749/b839c9b77b',
embed: 'https://player.vimeo.com/video/360087749',
duration: 218,
groups: [ 4, 2, 8 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168396_640x360.jpg?r=pad' },
{ name: 'Jordan (easy)',
vimeo: 'https://vimeo.com/360087692/166264a65f',
embed: 'https://player.vimeo.com/video/360087692',
duration: 231,
groups: [ 4, 2, 8 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168333_640x360.jpg?r=pad' },
{ name: 'Herkules (hard)',
vimeo: 'https://vimeo.com/360087648/249c34421b',
embed: 'https://player.vimeo.com/video/360087648',
duration: 507,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 3,
repetitions: [ 60 ],
preview: 'https://i.vimeocdn.com/video/814168895_640x360.jpg?r=pad' },
{ name: 'Jackman (moderate)',
vimeo: 'https://vimeo.com/360087631/dd115fbd95',
embed: 'https://player.vimeo.com/video/360087631',
duration: 523,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 2,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168287_640x360.jpg?r=pad' },
{ name: 'Herkules (easy)',
vimeo: 'https://vimeo.com/360087624/7e9d341425',
embed: 'https://player.vimeo.com/video/360087624',
duration: 509,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 1,
repetitions: [ 60 ],
preview: 'https://i.vimeocdn.com/video/814168269_640x360.jpg?r=pad' },
{ name: 'Hemsworth (moderate)',
vimeo: 'https://vimeo.com/360087606/4237645683',
embed: 'https://player.vimeo.com/video/360087606',
duration: 530,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814168254_640x360.jpg?r=pad' },
{ name: 'Jackman (hard)',
vimeo: 'https://vimeo.com/360087574/19891d9cf1',
embed: 'https://player.vimeo.com/video/360087574',
duration: 498,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 3,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168218_640x360.jpg?r=pad' },
{ name: 'Jackman (easy)',
vimeo: 'https://vimeo.com/360087526/f535bf8298',
embed: 'https://player.vimeo.com/video/360087526',
duration: 522,
groups: [ 14, 13, 6, 4, 2, 3, 1 ],
level: 1,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814168161_640x360.jpg?r=pad' },
{ name: 'Herkules (moderate)',
vimeo: 'https://vimeo.com/360087469/591fc90443',
embed: 'https://player.vimeo.com/video/360087469',
duration: 503,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 2,
repetitions: [ 60 ],
preview: 'https://i.vimeocdn.com/video/814168089_640x360.jpg?r=pad' },
{ name: 'Hemsworth (hard)',
vimeo: 'https://vimeo.com/360075518/343cd06bfc',
embed: 'https://player.vimeo.com/video/360075518',
duration: 499,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814152769_640x360.jpg?r=pad' },
{ name: 'Hemsworth (easy)',
vimeo: 'https://vimeo.com/360075490/503cf59fe2',
embed: 'https://player.vimeo.com/video/360075490',
duration: 526,
groups: [ 13, 14, 6, 11, 2, 4, 7 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814152714_640x360.jpg?r=pad' },
{ name: 'Gyllenhaal (moderate)',
vimeo: 'https://vimeo.com/360075470/f289c27cd8',
embed: 'https://player.vimeo.com/video/360075470',
duration: 207,
groups: [ 4, 12, 9 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814152691_640x360.jpg?r=pad' },
{ name: 'Gyllenhaal (hard)',
vimeo: 'https://vimeo.com/360075445/dc2591fb93',
embed: 'https://player.vimeo.com/video/360075445',
duration: 219,
groups: [ 4, 12, 9 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814152659_640x360.jpg?r=pad' },
{ name: 'Gyllenhaal (easy)',
vimeo: 'https://vimeo.com/360075408/95056ff57f',
embed: 'https://player.vimeo.com/video/360075408',
duration: 216,
groups: [ 4, 12, 9 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814152628_640x360.jpg?r=pad' },
{ name: 'Gosling (moderate)',
vimeo: 'https://vimeo.com/360075384/68397f37f4',
embed: 'https://player.vimeo.com/video/360075384',
duration: 226,
groups: [ 15, 7, 11 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814152591_640x360.jpg?r=pad' },
{ name: 'Gosling (hard)',
vimeo: 'https://vimeo.com/360075217/6b62fa52e4',
embed: 'https://player.vimeo.com/video/360075217',
duration: 217,
groups: [ 15, 7, 11 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814152349_640x360.jpg?r=pad' },
{ name: 'Gosling (easy)',
vimeo: 'https://vimeo.com/360075193/cd56aa2112',
embed: 'https://player.vimeo.com/video/360075193',
duration: 224,
groups: [ 15, 7, 11 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814152318_640x360.jpg?r=pad' },
{ name: 'Gladiator (moderate)',
vimeo: 'https://vimeo.com/360075073/6d9cd3c91e',
embed: 'https://player.vimeo.com/video/360075073',
duration: 503,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 2,
repetitions: [ 45, 45 ],
preview: 'https://i.vimeocdn.com/video/814152205_640x360.jpg?r=pad' },
{ name: 'Gladiator (hard)',
vimeo: 'https://vimeo.com/360075035/513fc54e99',
embed: 'https://player.vimeo.com/video/360075035',
duration: 507,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 3,
repetitions: [ 45, 45 ],
preview: 'https://i.vimeocdn.com/video/814152164_640x360.jpg?r=pad' },
{ name: 'Gladiator (easy)',
vimeo: 'https://vimeo.com/360074971/1ad645106a',
embed: 'https://player.vimeo.com/video/360074971',
duration: 509,
groups: [ 8, 2, 4, 11, 10, 9, 5 ],
level: 1,
repetitions: [ 45, 45 ],
preview: 'https://i.vimeocdn.com/video/814152098_640x360.jpg?r=pad' },
{ name: 'Farrell (moderate)',
vimeo: 'https://vimeo.com/360074933/8208596dc3',
embed: 'https://player.vimeo.com/video/360074933',
duration: 246,
groups: [ 14, 12, 13 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814152036_640x360.jpg?r=pad' },
{ name: 'Farrell (hard)',
vimeo: 'https://vimeo.com/360073416/5eb7e09a75',
embed: 'https://player.vimeo.com/video/360073416',
duration: 226,
groups: [ 14, 12, 13 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814150079_640x360.jpg?r=pad' },
{ name: 'Farrell (easy)',
vimeo: 'https://vimeo.com/360073394/ede743b72b',
embed: 'https://player.vimeo.com/video/360073394',
duration: 243,
groups: [ 14, 12, 13 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814150045_640x360.jpg?r=pad' },
{ name: 'Dornan (moderate)',
vimeo: 'https://vimeo.com/360073366/54aa0ec184',
embed: 'https://player.vimeo.com/video/360073366',
duration: 347,
groups: [ 11, 10, 12, 4, 9 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814150009_640x360.jpg?r=pad' },
{ name: 'Dornan (hard)',
vimeo: 'https://vimeo.com/360073332/420eed4dd8',
embed: 'https://player.vimeo.com/video/360073332',
duration: 374,
groups: [ 11, 10, 12, 4, 9 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814149979_640x360.jpg?r=pad' },
{ name: 'Dornan (easy)',
vimeo: 'https://vimeo.com/360072881/9d489d9ff7',
embed: 'https://player.vimeo.com/video/360072881',
duration: 362,
groups: [ 11, 10, 12, 4, 9 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814149947_640x360.jpg?r=pad' },
{ name: 'Diego (moderate)',
vimeo: 'https://vimeo.com/360072837/86b305784d',
embed: 'https://player.vimeo.com/video/360072837',
duration: 337,
groups: [ 5, 11, 4, 6, 1 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814149315_640x360.jpg?r=pad' },
{ name: 'Diego (hard)',
vimeo: 'https://vimeo.com/360072370/5270997243',
embed: 'https://player.vimeo.com/video/360072370',
duration: 330,
groups: [ 5, 11, 4, 6, 1 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814148765_640x360.jpg?r=pad' },
{ name: 'Diego (easy)',
vimeo: 'https://vimeo.com/360072338/b7e688ed88',
embed: 'https://player.vimeo.com/video/360072338',
duration: 335,
groups: [ 5, 11, 4, 6, 1 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814148730_640x360.jpg?r=pad' },
{ name: 'Denzel (moderate)',
vimeo: 'https://vimeo.com/360072305/d3b7b9d601',
embed: 'https://player.vimeo.com/video/360072305',
duration: 373,
groups: [ 10, 13, 15, 2, 3 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814148688_640x360.jpg?r=pad' },
{ name: 'Denzel (hard)',
vimeo: 'https://vimeo.com/360072278/6a964617e6',
embed: 'https://player.vimeo.com/video/360072278',
duration: 366,
groups: [ 10, 13, 15, 2, 3 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814148652_640x360.jpg?r=pad' },
{ name: 'Denzel (easy)',
vimeo: 'https://vimeo.com/360072249/693b1c6cc9',
embed: 'https://player.vimeo.com/video/360072249',
duration: 376,
groups: [ 10, 13, 15, 2, 3 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814148624_640x360.jpg?r=pad' },
{ name: 'Damon (moderate)',
vimeo: 'https://vimeo.com/360072154/239be8f51c',
embed: 'https://player.vimeo.com/video/360072154',
duration: 197,
groups: [ 10, 10, 11 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148464_640x360.jpg?r=pad' },
{ name: 'Damon (hard)',
vimeo: 'https://vimeo.com/360072128/8e4275e4e3',
embed: 'https://player.vimeo.com/video/360072128',
duration: 227,
groups: [ 10, 10, 11 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148447_640x360.jpg?r=pad' },
{ name: 'Damon (easy)',
vimeo: 'https://vimeo.com/360072085/5c53c61eb3',
embed: 'https://player.vimeo.com/video/360072085',
duration: 212,
groups: [ 10, 10, 11 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148386_640x360.jpg?r=pad' },
{ name: 'Craig (moderate)',
vimeo: 'https://vimeo.com/360071960/47c10e4c02',
embed: 'https://player.vimeo.com/video/360071960',
duration: 472,
groups: [ 10, 5, 11, 9, 15, 6, 11 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148260_640x360.jpg?r=pad' },
{ name: 'Craig (hard)',
vimeo: 'https://vimeo.com/360071902/63245be399',
embed: 'https://player.vimeo.com/video/360071902',
duration: 474,
groups: [ 10, 5, 11, 9, 15, 6, 11 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148170_640x360.jpg?r=pad' },
{ name: 'Craig (easy)',
vimeo: 'https://vimeo.com/360071852/c4d9100039',
embed: 'https://player.vimeo.com/video/360071852',
duration: 478,
groups: [ 10, 5, 11, 9, 15, 6, 11 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814148044_640x360.jpg?r=pad' },
{ name: 'Cooper (moderate)',
vimeo: 'https://vimeo.com/360071795/c49d15be35',
embed: 'https://player.vimeo.com/video/360071795',
duration: 493,
groups: [ 14, 6, 11, 4, 12, 9, 5 ],
level: 2,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814147971_640x360.jpg?r=pad' },
{ name: 'Cooper (hard)',
vimeo: 'https://vimeo.com/360028880/c543e0acf8',
embed: 'https://player.vimeo.com/video/360028880',
duration: 485,
groups: [ 14, 6, 11, 4, 12, 9, 5 ],
level: 3,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814090982_640x360.jpg?r=pad' },
{ name: 'Cooper (easy)',
vimeo: 'https://vimeo.com/360028828/b2a934f0b1',
embed: 'https://player.vimeo.com/video/360028828',
duration: 505,
groups: [ 14, 6, 11, 4, 12, 9, 5 ],
level: 1,
repetitions: [ 60, 60, 45, 45, 30, 30 ],
preview: 'https://i.vimeocdn.com/video/814090927_640x360.jpg?r=pad' },
{ name: 'Clooney (moderate)',
vimeo: 'https://vimeo.com/360028771/fbd297657f',
embed: 'https://player.vimeo.com/video/360028771',
duration: 488,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090849_640x360.jpg?r=pad' },
{ name: 'Clooney (hard)',
vimeo: 'https://vimeo.com/360028725/f88b04209d',
embed: 'https://player.vimeo.com/video/360028725',
duration: 503,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090803_640x360.jpg?r=pad' },
{ name: 'Clooney (easy)',
vimeo: 'https://vimeo.com/360028667/2432778e3b',
embed: 'https://player.vimeo.com/video/360028667',
duration: 502,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090740_640x360.jpg?r=pad' },
{ name: 'Chan (moderate)',
vimeo: 'https://vimeo.com/360028605/0ddccaa224',
embed: 'https://player.vimeo.com/video/360028605',
duration: 198,
groups: [ 4, 5, 11 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090643_640x360.jpg?r=pad' },
{ name: 'Chan (hard)',
vimeo: 'https://vimeo.com/360028557/e216806563',
embed: 'https://player.vimeo.com/video/360028557',
duration: 196,
groups: [ 4, 5, 11 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090585_640x360.jpg?r=pad' },
{ name: 'Chan (easy)',
vimeo: 'https://vimeo.com/360028513/e15d545ba9',
embed: 'https://player.vimeo.com/video/360028513',
duration: 201,
groups: [ 4, 5, 11 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814090521_640x360.jpg?r=pad' },
{ name: 'Butler (moderate)',
vimeo: 'https://vimeo.com/360028213/988a8e2918',
embed: 'https://player.vimeo.com/video/360028213',
duration: 364,
groups: [ 15, 9, 5, 2, 7 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814090077_640x360.jpg?r=pad' },
{ name: 'Butler (hard)',
vimeo: 'https://vimeo.com/360028159/d93f6cd2af',
embed: 'https://player.vimeo.com/video/360028159',
duration: 349,
groups: [ 15, 9, 5, 2, 7 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814090030_640x360.jpg?r=pad' },
{ name: 'Butler (easy)',
vimeo: 'https://vimeo.com/360028045/21ec4815bb',
embed: 'https://player.vimeo.com/video/360028045',
duration: 366,
groups: [ 15, 9, 5, 2, 7 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814089898_640x360.jpg?r=pad' },
{ name: 'Bond (moderate)',
vimeo: 'https://vimeo.com/360027928/779a662cb6',
embed: 'https://player.vimeo.com/video/360027928',
duration: 400,
groups: [ 12, 3, 14, 13, 1 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814089697_640x360.jpg?r=pad' },
{ name: 'Bond (hard)',
vimeo: 'https://vimeo.com/360027788/398f3adaad',
embed: 'https://player.vimeo.com/video/360027788',
duration: 385,
groups: [ 12, 3, 14, 13, 1 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814089488_640x360.jpg?r=pad' },
{ name: 'Bond (easy)',
vimeo: 'https://vimeo.com/360027191/6645be3e5e',
embed: 'https://player.vimeo.com/video/360027191',
duration: 392,
groups: [ 12, 3, 14, 13, 1 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814088743_640x360.jpg?r=pad' },
{ name: 'Bolt (moderate)',
vimeo: 'https://vimeo.com/360027152/ab3b3b54ef',
embed: 'https://player.vimeo.com/video/360027152',
duration: 210,
groups: [ 10, 3, 1 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814088643_640x360.jpg?r=pad' },
{ name: 'Bolt (hard)',
vimeo: 'https://vimeo.com/360027109/8579336b02',
embed: 'https://player.vimeo.com/video/360027109',
duration: 229,
groups: [ 10, 3, 1 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814088602_640x360.jpg?r=pad' },
{ name: 'Bolt (easy)',
vimeo: 'https://vimeo.com/360026782/c2711a717d',
embed: 'https://player.vimeo.com/video/360026782',
duration: 215,
groups: [ 10, 3, 1 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814088253_640x360.jpg?r=pad' },
{ name: 'Bloom (moderate)',
vimeo: 'https://vimeo.com/360026737/7ffa3cd9e9',
embed: 'https://player.vimeo.com/video/360026737',
duration: 498,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 2,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814088211_640x360.jpg?r=pad' },
{ name: 'Bloom (hard)',
vimeo: 'https://vimeo.com/360026567/682a9d1e6e',
embed: 'https://player.vimeo.com/video/360026567',
duration: 512,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 3,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814087973_640x360.jpg?r=pad' },
{ name: 'Bloom (easy)',
vimeo: 'https://vimeo.com/360026486/d67f7e1081',
embed: 'https://player.vimeo.com/video/360026486',
duration: 504,
groups: [ 8, 3, 4, 11, 10, 9, 5 ],
level: 1,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814087893_640x360.jpg?r=pad' },
{ name: 'Beine-Special (moderate)',
vimeo: 'https://vimeo.com/360026346/7bf6d1f2e9',
embed: 'https://player.vimeo.com/video/360026346',
duration: 314,
groups: [ 9, 13, 8, 1 ],
level: 2,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814087730_640x360.jpg?r=pad' },
{ name: 'Beine-Special (hard)',
vimeo: 'https://vimeo.com/360026202/a29b264430',
embed: 'https://player.vimeo.com/video/360026202',
duration: 298,
groups: [ 9, 13, 8, 1 ],
level: 3,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814087557_640x360.jpg?r=pad' },
{ name: 'Beine-Special (easy)',
vimeo: 'https://vimeo.com/360026080/28a447fbb5',
embed: 'https://player.vimeo.com/video/360026080',
duration: 290,
groups: [ 9, 13, 8, 1 ],
level: 1,
repetitions: [ 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814087356_640x360.jpg?r=pad' },
{ name: 'Arnold (moderate)',
vimeo: 'https://vimeo.com/360016079/5d9d0e78fa',
embed: 'https://player.vimeo.com/video/360016079',
duration: 488,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 2,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074485_640x360.jpg?r=pad' },
{ name: 'Arnold (hard)',
vimeo: 'https://vimeo.com/360016042/3597ba494b',
embed: 'https://player.vimeo.com/video/360016042',
duration: 503,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 3,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074445_640x360.jpg?r=pad' },
{ name: 'Arnold (easy)',
vimeo: 'https://vimeo.com/360016004/972cb75e79',
embed: 'https://player.vimeo.com/video/360016004',
duration: 502,
groups: [ 9, 10, 11, 2, 4, 12, 6 ],
level: 1,
repetitions: [ 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074389_640x360.jpg?r=pad' },
{ name: 'Ali (moderate)',
vimeo: 'https://vimeo.com/360015965/90f4291f2d',
embed: 'https://player.vimeo.com/video/360015965',
duration: 385,
groups: [ 6, 7, 3, 8, 2 ],
level: 2,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074301_640x360.jpg?r=pad' },
{ name: 'Ali (hard)',
vimeo: 'https://vimeo.com/360015938/1fbb049b77',
embed: 'https://player.vimeo.com/video/360015938',
duration: 366,
groups: [ 6, 7, 3, 8, 2 ],
level: 3,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074269_640x360.jpg?r=pad' },
{ name: 'Ali (easy)',
vimeo: 'https://vimeo.com/360015896/4685a052ab',
embed: 'https://player.vimeo.com/video/360015896',
duration: 374,
groups: [ 6, 7, 3, 8, 2 ],
level: 1,
repetitions: [ 45, 60, 90 ],
preview: 'https://i.vimeocdn.com/video/814074141_640x360.jpg?r=pad' },
{ name: 'Affleck (moderate)',
vimeo: 'https://vimeo.com/360015872/0373abead7',
embed: 'https://player.vimeo.com/video/360015872',
duration: 358,
groups: [ 1, 2, 3, 4, 5 ],
level: 2,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814074098_640x360.jpg?r=pad' },
{ name: 'Affleck (hard)',
vimeo: 'https://vimeo.com/360015838/c40aae6f59',
embed: 'https://player.vimeo.com/video/360015838',
duration: 354,
groups: [ 1, 2, 3, 4, 5 ],
level: 3,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814074050_640x360.jpg?r=pad' },
{ name: 'Affleck (easy)',
vimeo: 'https://vimeo.com/360015810/bd97f5fa30',
embed: 'https://player.vimeo.com/video/360015810',
duration: 360,
groups: [ 1, 2, 3, 4, 5 ],
level: 1,
repetitions: [ 45, 60, 90, 60, 45 ],
preview: 'https://i.vimeocdn.com/video/814073983_640x360.jpg?r=pad' }
]
}

const getRandom = (arr, n) => {
  var result = new Array(n),
      len = arr.length,
      taken = new Array(len)
  if (n > len)
      throw new RangeError('getRandom: more elements taken than available')
  while (n--) {
      var x = Math.floor(Math.random() * len)
      result[n] = arr[x in taken ? taken[x] : x]
      taken[x] = --len in taken ? taken[len] : len
  }
  return result;
}

const addWorkoutsToGroup = (state, group) => {
const el = Object.assign({}, group)
el.workouts = group.groups.map(g => {
  const video = state.videos.find(v => v.group === g && v.level === group.level)
  video.vidpath = `http://assets.keepyou.fit/viden/${ video.vidname }.mp4`
  video.preview = `http://assets.keepyou.fit/preven/${ video.vidname }.png`
  video.mode = '640x315'
  return video
})
el.preview = `http://assets.keepyou.fit/prevth/${ el.workouts[0].vidname }.png`
el.duration = el.workouts.reduce((sum, workout) => sum + workout.duration, 0) * el.repetitions.length + 10 * (el.repetitions.length * el.workouts.length - 1)
el.time = Math.floor(el.duration/60) + ':' + ('0' + el.duration%60).slice(-2)
return el
}

const getters = {
getTrainingsByLevel: state => level => {
    return state.combos.filter(i => i.level === level )
      .map(item => addWorkoutsToGroup(state, item))
},
getRandomTraining: state => level => {
    return addWorkoutsToGroup(state, getRandom(state.combos.filter(i => i.level === level), 1)[0])
},
getTrainingByName: state => name => {
    let group = state.combos.find(i => i.name === name)
    if (group === null || group === undefined) {
      group = state.videos.find(i => i.name === name)
      group.groups = [group.group]
      group.workouts = [group]
      group.time = Math.floor(group.duration/60) + ':' + ('0' + group.duration%60).slice(-2)
      group.repetitions = [60]
      group.isTraining = false
      return group
    } else {
      return addWorkoutsToGroup(state, group)
    }
},
getWorkoutByGroupAndLevel: state => (group, level) => {
    return state.videos.find(i => i.level === level && i.group === group)
},
getWorkoutsByGroupAndLevel: state => (groups, level) => {
    return state.videos.filter(i => i.level === level && groups.indexOf(i.group) >= 0)
},
getWorkoutsByLevel: state => level => {
  return state.videos.filter(i => i.level === level )
    .map(item => {
      item.groups = [item.group]
      item.workouts = [item]
      item.time = Math.floor(item.duration/60) + ':' + ('0' + item.duration%60).slice(-2)
      item.repetitions = [60]
      item.isTraining = false
      return item
    })
}
}

export default {
state,
getters
}


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/workoutsAT.js